// Minimal DOM helpers for the HUD: no framework is needed for H0's handful of controls.

type Attrs = Record<string, string | number | boolean | undefined>;

export function h<K extends keyof HTMLElementTagNameMap>(tag: K, attrs: Attrs = {}, ...children: (Node | string)[]): HTMLElementTagNameMap[K] {
  const el = document.createElement(tag);
  for (const [key, value] of Object.entries(attrs)) {
    if (value === undefined || value === false) continue;
    if (key === 'class') el.className = String(value);
    else el.setAttribute(key, value === true ? '' : String(value));
  }
  el.append(...children);
  return el;
}

/** Wraps an inline SVG string (a Phosphor icon) in a span sized by the font size. */
export function icon(svg: string, className = 'icon'): HTMLSpanElement {
  const el = h('span', { class: className, 'aria-hidden': 'true' });
  el.innerHTML = svg;
  return el;
}

/** Spanish number formatting of the design system: «.» as thousands separator, even for 4 digits. */
export function formatNumber(n: number, decimals = 0): string {
  const fixed = Math.abs(n).toFixed(decimals);
  const [int = '0', frac] = fixed.split('.');
  const grouped = int.replace(/\B(?=(\d{3})+(?!\d))/g, '.');
  return (n < 0 ? '-' : '') + grouped + (frac ? `,${frac}` : '');
}
